if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) {
          this.renderError();
          return;
        }

        let rootUrl =
          typeof window !== 'undefined' &&
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root != null
            ? window.Shopify.routes.root
            : this.dataset.rootUrl || '/';
        if (typeof rootUrl === 'string' && !rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }

        const productUrl = this.dataset.productUrl;
        const urls = [`${rootUrl}variants/${variantId}/?section_id=pickup-availability`];
        if (productUrl) {
          const base = productUrl.split('?')[0];
          urls.push(
            `${base}?variant=${encodeURIComponent(variantId)}&section_id=pickup-availability`
          );
          urls.push(
            `${base}?variant=${encodeURIComponent(variantId)}&sections=pickup-availability`
          );
        }

        const tryFetch = (index) => {
          if (index >= urls.length) {
            this.renderError();
            return;
          }
          fetch(urls[index])
            .then((response) => response.text().then((text) => ({ ok: response.ok, text })))
            .then(({ ok, text }) => {
              const sectionRoot = this.resolveSectionRootFromResponse(text);
              const hasPreview =
                sectionRoot && sectionRoot.querySelector('pickup-availability-preview');
              if (!ok || !hasPreview) {
                tryFetch(index + 1);
                return;
              }
              this.renderPreview(sectionRoot);
            })
            .catch(() => {
              tryFetch(index + 1);
            });
        };

        tryFetch(0);
      }

      /**
       * Section Rendering API returns JSON when using `sections=`.
       * @param {string} text
       * @returns {Element|null}
       */
      resolveSectionRootFromResponse(text) {
        if (typeof text !== 'string' || !text.length) return null;
        const trimmed = text.trimStart();
        if (trimmed.startsWith('{')) {
          try {
            const json = JSON.parse(text);
            const sectionHtml = json['pickup-availability'];
            if (typeof sectionHtml === 'string' && sectionHtml.length) {
              return this.parseSectionRoot(sectionHtml);
            }
          } catch {
            return null;
          }
          return null;
        }
        return this.parseSectionRoot(text);
      }

      parseSectionRoot(htmlText) {
        if (typeof htmlText !== 'string' || !htmlText.length) return null;
        const doc = new DOMParser().parseFromString(htmlText, 'text/html');
        return (
          doc.querySelector('.shopify-section') ||
          doc.querySelector('[id^="shopify-section-"]') ||
          (doc.querySelector('pickup-availability-preview') ? doc.body : null)
        );
      }

      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        const refreshButton = this.querySelector('.pickup-availability-button');
        if (refreshButton) refreshButton.addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        document.querySelectorAll('pickup-availability-drawer').forEach((el) => el.remove());
        if (
          !sectionInnerHTML ||
          !sectionInnerHTML.querySelector('pickup-availability-preview')
        ) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        const drawer = sectionInnerHTML.querySelector('pickup-availability-drawer');
        if (drawer) {
          const mountTarget = this.closest('cart-drawer') || document.body;
          mountTarget.appendChild(drawer);
        }

        const button = this.querySelector('.pickup-availability-button');
        if (button) {
          button.addEventListener('click', (evt) => {
            const cartDrawer = this.closest('cart-drawer');
            let openDrawer = cartDrawer
              ? cartDrawer.querySelector('pickup-availability-drawer')
              : null;
            if (!openDrawer) {
              openDrawer = document.querySelector('pickup-availability-drawer');
            }
            if (openDrawer) openDrawer.show(evt.target);
          });
        }
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          !target.closest('.pickup-availability-button')
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );
}
